/*
 * View showing the table listing of entries for a substitution group
 */

define([
  "marionette",
  "modules/substitutions/substitutionGroup/substitutionGroupEntries/template/substitutionGroupEntriesTemplate.html",
  "modules/substitutions/substitutionGroup/substitutionGroupEntries/template/substitutionGroupEntryTemplate.html",
], function (Marionette, SubstitutionGroupEntriesTemplate, SubstitutionGroupEntryTemplate) {
  var SubstitutionGroupEntriesView = {};

  SubstitutionGroupEntriesView.substitutionGroupEntryView = Marionette.ItemView.extend({
    template: SubstitutionGroupEntryTemplate,
    tagName: "tr",
    textboxes: {
      "#entryName": {
        enableSelector: "#entryName",
        modelAttribute: "entrySurfaceForm",
        placeholder: "substitutions.entries.entryName",
        textArea: false,
      },
    },
    triggers: {
      "click #entryDefault": "toggle:default:entry",
      "click #entryDelete": "delete:entry",
    },
    modelEvents: {
      "change entrySurfaceForm": "render",
      "change:defaultEntry": function () {
        //update checkmark using Jquery without a view render
        var isDefault = this.model.get("defaultEntry");
        if (isDefault) {
          this.$el.find("#entryDefault i").removeClass("icon-check-empty").addClass("icon-check");
        } else {
          this.$el.find("#entryDefault i").removeClass("icon-check").addClass("icon-check-empty");
        }
      },
    },
  });

  SubstitutionGroupEntriesView.substitutionGroupEntriesView = Marionette.CompositeView.extend({
    template: SubstitutionGroupEntriesTemplate,
    itemView: SubstitutionGroupEntriesView.substitutionGroupEntryView,
    itemViewContainer: "tbody",
    triggers: {
      "click #addEntry": "add:entry",
      "click #history": "get:history",
    },
    collectionEvents: {
      sort: "renderSpecial",
    },
    emptyError: function (errorMessage) {
      this.$el
        .find("#entryError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    onAfterItemAdded: function (itemView) {
      //remove delete button if there is only one entry
      if (this.collection.size() === 1) {
        itemView.$el.find("#entryDelete").html("");
      }
    },
    onItemRemoved: function (itemView) {
      //remove delete button if there's now only one view (entry)
      if (this.children.length === 1) {
        this.children.first().$el.find("#entryDelete").html("");
      }
    },
    renderSpecial: function () {
      //clear any tooltips and then re-render
      this.$el.find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]').tooltip("destroy");
      this.render();
    },
  });

  return SubstitutionGroupEntriesView;
});
